import { render, staticRenderFns } from "./heads.vue?vue&type=template&id=aa544436&scoped=true&"
import script from "./heads.vue?vue&type=script&lang=js&"
export * from "./heads.vue?vue&type=script&lang=js&"
import style0 from "./heads.vue?vue&type=style&index=0&id=aa544436&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa544436",
  null
  
)

export default component.exports